import { Injectable } from "@angular/core";
import { AbstractControlOptions, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ReactiveFormHelper } from "@utils/classes/reactive-form-helper";

@Injectable({
  providedIn: 'root'
})
export class PageUserInforPresenter {
  form_billing = {
    title1: 'Ingresa los datos del',
    title2: 'titular de la tarjeta de',
    title3: 'débito',
    title4: 'que usarás para realizar el pago.',
  };

  private fb: UntypedFormBuilder = new UntypedFormBuilder();
  userInfoFrom: UntypedFormGroup = this.fb.group({
    doc_type: [ 'DNI', [ Validators.required ] ],
    dni: [ '' ],
    name: [ '', [ Validators.required, Validators.min(2), Validators.pattern(/^[a-zA-Z\u00C0-\u017F\s]{2,50}$/) ] ],
    lastname: [ '', [ Validators.required, Validators.min(2), Validators.pattern(/[a-zA-Z\u00C0-\u017F\s]{2,30}/) ] ],
    email: [ '', [ Validators.required, Validators.email ] ],
    phone: [ '', [ Validators.required, Validators.pattern(/^\d{9}$/), Validators.min(10) ] ],

  }, {
    validator: [ this.formularioValidator ]
  } as AbstractControlOptions)

  formularioValidator(form: UntypedFormGroup): any {
    // Accede a los campos del formulario que necesitas validar
    const tipoDoc = form.get('doc_type')?.value;
    const dniNumber = form.get('dni')?.value;
    if (tipoDoc === 'DNI' && dniNumber.length != 8) {
      form.get('dni')?.setErrors({ dniInvalido: true });
    }

    if (tipoDoc === 'CE' && dniNumber.length < 9 || dniNumber.length > 12) {
      form.get('dni')?.setErrors({ ceInvalido: true });
    }
  }

  formItems: FormItems = {
    doc_type: {
      control: 'doc_type',
      label: 'I',
      errors: {
        required: 'DNI obligatorio',
      }
    },
    dni: {
      control: 'dni',
      label: 'Ingrese su DNI',
      errors: {
        required: 'documento de identidad obligatorio',
        dniInvalido: 'Ingresa un número de documento válido',
        ceInvalido: 'Ingresa un número de documento válido',
      }
    },
    name: {
      control: 'name',
      label: 'Nombres',
      errors: {
        required: 'Nombres obligatorio',
        min: 'Debes ingresar almenos 2 caracteres.',
        pattern: 'El nombre no permite caracteres especiales y/o simbolos'
      }
    },
    lastname: {
      control: 'lastname',
      label: 'Apellidos',
      errors: {
        required: 'Apellidos obligatorio',
        min: 'Debes ingresar almenos 2 caracteres.',
        pattern: 'El apellido no permite caracteres especiales y/o simbolos'
      }
    },
    email: {
      control: 'email',
      label: 'Email',
      errors: {
        required: 'Email obligatorio',
        email: 'Ingrese un email válido'
      }
    },
    phone: {
      control: 'phone',
      label: 'Teléfono',
      errors: {
        required: 'Debes ingresar el celular',
        pattern: 'Numero de celular no valido'
      }
    }
  };

  reactiveFormHelper = new ReactiveFormHelper(this.userInfoFrom, this.formItems);

  getErrors(controlName: string) {
    return this.reactiveFormHelper.getErrors(controlName);
  }

  isFormValid() {
    return this.userInfoFrom.valid;
  }

  getFormData() {
    return this.userInfoFrom.value;
  }

  markAsTouched() {
    for (const i in this.userInfoFrom.controls) {
      this.userInfoFrom.controls[i].markAsTouched();
      this.userInfoFrom.controls[i].markAsDirty();
    }
  }
}

export interface FormItem {
  control: string;
  label: string;
  errors: {
    required: string;
    email?: string;
    pattern?: string;
    min?: string;
    maxlength?: string;
    dniInvalido?: string;
    ceInvalido?: string;
  };
}

export interface FormItems {
  dni: FormItem;
  name: FormItem;
  lastname: FormItem;
  email: FormItem;
  phone: FormItem;
  [propName: string]: FormItem;
}
